import { Modal, Badge, Card, Row, Col } from 'react-bootstrap';
import type { DashboardRecentBooking } from '../../types/dashboard';

interface DashboardBookingPreviewModalProps {
  show: boolean;
  onHide: () => void;
  booking: DashboardRecentBooking | null;
}

const DashboardBookingPreviewModal = ({
  show,
  onHide,
  booking,
}: DashboardBookingPreviewModalProps) => {
  if (!booking) return null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi-ticket-perforated me-2"></i>
          Booking Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Booking Information */}
        <Card className="mb-3">
          <Card.Header>
            <h6 className="mb-0">Booking Information</h6>
          </Card.Header>

          <Card.Body>
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <small className="text-muted">Booking ID</small>
                  <div className="fw-medium">
                    <code>{booking.bookingNumber}</code>
                  </div>
                </div>

                <div className="mb-3">
                  <small className="text-muted">Customer</small>
                  <div className="fw-medium">{booking.customer}</div>
                </div>

                <div className="mb-3">
                  <small className="text-muted">Movie</small>
                  <div className="fw-medium">{booking.movie}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <small className="text-muted">Cinema</small>
                  <div className="fw-medium">{booking.cinema}</div>
                </div>

                <div className="mb-3">
                  <small className="text-muted">Booked On</small>
                  <div className="fw-medium">
                    {new Date(booking.bookingDate).toLocaleString()}
                  </div>
                </div>

                <div className="mb-3">
                  <small className="text-muted">Amount</small>
                  <div className="fw-medium fs-5 text-success">
                    {booking.amount}
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <small className="text-muted">Status</small>
                <div>
                  <Badge
                    bg={
                      booking.status === 'confirmed'
                        ? 'success'
                        : booking.status === 'pending'
                        ? 'warning'
                        : 'danger'
                    }
                  >
                    {booking.status}
                  </Badge>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Info note */}
        <small className="text-muted">
          <i className="bi-info-circle me-1"></i>
          This is a summary view. Open the Bookings page to see full details.
        </small>
      </Modal.Body>
    </Modal>
  );
};

export default DashboardBookingPreviewModal;
